export const ADD_PROMPT_TO_QUEUE = 'ADD_PROMPT_TO_QUEUE';
export const REMOVE_PROMPT_FROM_QUEUE = 'REMOVE_PROMPT_FROM_QUEUE';
export const CLEAR_PROMPT_QUEUE = 'CLEAR_PROMPT_QUEUE';
export const RESET_PROMPT_QUEUE = 'RESET_PROMPT_QUEUE';
export const INITIALIZE_PROMPT_QUEUE = 'INITIALIZE_PROMPT_QUEUE';

export const addPromptToQueue = (promptId) => ({
    type: ADD_PROMPT_TO_QUEUE,
    promptId
});

export const removePromptFromQueue = (promptId) => ({
    type: REMOVE_PROMPT_FROM_QUEUE,
    promptId
});

export const clearPromptQueue = () => ({
    type: CLEAR_PROMPT_QUEUE
});

export const resetPromptQueue = () => ({
    type: RESET_PROMPT_QUEUE
});

export const initializePromptQueue = (assessment, prompts) => ({
    type: INITIALIZE_PROMPT_QUEUE,
    assessment,
    prompts
});